import { mensagemPadrao } from 'src/dados-estaticos'
import { SituacaoUpload } from 'src/tipos'
import * as Yup from 'yup'

export const createSchema = Yup.object().shape({
  nome: Yup.string().required(mensagemPadrao),
  cursoCertificacaoId: Yup.string().required(mensagemPadrao),
  tipo: Yup.string().required(mensagemPadrao),
  divisao: Yup.string().required(mensagemPadrao),
  cargaHoraria: Yup.string().required(mensagemPadrao),
  dataInicio: Yup.date().required(mensagemPadrao),
  dataFim: Yup.date().when('tipo', {
    is: (tipo: string) => tipo !== 'Aberta',
    then: schema => schema.required(mensagemPadrao),
    otherwise: schema => schema.notRequired().nullable()
  }),
  status: Yup.string().required(mensagemPadrao)
  // documentos: Yup.array()
  //   .ensure()
  //   .test('documento-enviado', 'É obrigatório enviar o PPC.', value => {
  //     const docs = value as { status: SituacaoUpload }[]
  //     return (
  //       docs?.some(
  //         doc =>
  //           doc.status === SituacaoUpload.AguardandoAnalise ||
  //           doc.status === SituacaoUpload.Aprovado
  //       ) ?? false
  //     )
  //   })
})

// hyjhgfjygfkjgkyg
